import {
  MultiInputDateRangeField as MuiMultiInputDateRangeField,
  MultiInputDateRangeFieldProps,
} from "@mui/x-date-pickers-pro/MultiInputDateRangeField";

const MultiInputDateRangeField = (props: MultiInputDateRangeFieldProps<false>) => {
  const { format = "DD / MM / YYYY", ...rest } = props;
  return <MuiMultiInputDateRangeField {...rest} format={format} />;
};

export default MultiInputDateRangeField;
